import { ArrowLeft } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

import { ErrorState } from '@/components/shared/error-state';
import { Button } from '@/components/ui/button';
import { getErrorMessage } from '@/lib/errors';

import { NotFoundPage } from '@/features/system/pages/not-found-page';

/** Catches render/loader errors inside the shell so navigation stays usable. */
export function RouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  if (import.meta.env.DEV) {
    console.error(error);
  }

  return (
    <div className="py-10">
      <ErrorState
        title="Algo salió mal al mostrar esta sección"
        description={
          import.meta.env.DEV
            ? getErrorMessage(error)
            : 'El error fue registrado. Recarga la página o vuelve al panel general.'
        }
        onRetry={() => {
          window.location.reload();
        }}
      />
      <div className="mt-4 flex justify-center">
        <Button asChild variant="link" size="sm">
          <Link to="/dashboard">
            <ArrowLeft aria-hidden="true" />
            Volver al panel general
          </Link>
        </Button>
      </div>
    </div>
  );
}
